import styled, {css} from 'styled-components';

import {colors, breakpoint, border, font} from 'theme';

export const FormWrapper = styled.div`
    width: 100%;
    margin-left: 0;
    padding-bottom: 50px;

    @media (min-width: ${breakpoint.tablet}) {
        margin-left: 320px;
        width: 300px;
    }
`;

export const FormField = styled.div`
    margin-bottom: 15px;
`;

export const FormContainer = styled.div`
    padding-bottom: 60px;
    box-sizing: border-box;
    position: relative;
`;

export const NavigationButtonsContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 20px;
    position: absolute;
    bottom: 0;
    width: 100%;
`;

export const Row = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 10px;
`;

export const Column = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    min-width: 200px;
    margin: 0 5px 5px 5px;
`;

export const Fieldset = styled.fieldset`
    border: none;
    padding: 0;
`;

export const TitleWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;
    height: 100%;
`;

export const FormPartDescription = styled.div`
    font-size: 12px;
    line-height: 20px;
    color: ${colors.textSecondary};
`;

export const FormPartTitle = styled.div`
    font-weight: 700;
    font-size: 12px;
`;

export const ErrorList = styled.ul`
    margin-left: 0;
    padding-left: 17px;
`;
export const ErrorItem = styled.li`
    color: ${colors.danger};
    font-size: 14px;
    line-height: 20px;
`;

export const PreviewFileNameContainer = styled.div`
    margin-bottom: 20px;
`;

export const CountErrorMessage = styled.span`
    padding: 0 10px;
    font-size: 12px;
    line-height: 40px;
    color: ${colors.textMuted};
`;

export const AvailableCodesContainer = styled.div<{noAvailable?: boolean}>`
    font-size: 14px;
    margin-top: 8px;
    ${(p) =>
        p.noAvailable &&
        css`
            color: ${colors.danger};
        `}
`;

export const ProductGroupIconContainer = styled.div`
    padding-top: 23px;
    position: absolute;
    left: -60px;
`;

export const ProductTypesWrapper = styled.div`
    display: flex;
    align-items: stretch;
    justify-content: stretch;
    gap: 10px;
    width: 50%;
    height: 100%;
    box-sizing: border-box;
    padding: 16px 40px 16px 16px;
    border: 1px solid ${colors.brandPrimary};
    border-radius: ${border.radius};
    background-color: #f2f7ff;
`;

export const ProductTypesIconSection = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: center;
    width: 40px;
    height: 100%;
`;

export const ProductTypesDescription = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: stretch;
    flex: 1;
    height: 100%;
    gap: 16px;
`;

export const ProductTypesButtons = styled.div`
    display: flex;
    gap: 10px;
    align-items: flex-start;
    justify-content: stretch;
    width: 100%;
    height: 100%;
`;

export const ProductTypesButtonContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    height: 100%;

    > span:first-child {
        font-family: ${font.family.primary};
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        text-align: center;
        color: ${colors.darkGrey};
    }

    > span:last-child {
        font-family: ${font.family.primary};
        font-weight: 400;
        font-size: 14px;
        line-height: 21px;
        text-align: center;
        color: ${colors.textSecondary};
    }
`;

export const OrderFormWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    background-color: #f5f7f9;
    box-sizing: border-box;
    padding: 12px;
    border-radius: ${border.radius};
    margin-bottom: 20px;
`;

export const OrderFormWrapperTitle = styled.span`
    font-family: ${font.family.primary};
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: ${colors.textSecondary};
`;

export const OrderFormWrapperTitleValue = styled.span`
    font-family: ${font.family.primary};
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    color: ${colors.darkGrey};
`;

export const SeparationLine = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 15px;
    margin: 20px 0;

    &:before {
        content: '';
        position: absolute;
        top: 50%;
        left: 0;
        width: 100%;
        height: 1px;
        background-color: ${colors.border};
    }
`;
export const SeparationLineText = styled.span`
    z-index: 1;
    font-family: ${font.family.primary};
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: ${colors.textSecondary};
    padding: 4px 16px;
    background-color: #f5f7f9;
    border-radius: ${border.radius};
`;

export const ProductSingleItemRoot = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: auto;
    border: 1px solid #e2e2e2;
    box-sizing: border-box;
    padding: 16px;
    border-radius: ${border.radius};
    margin-top: 20px;
    gap: 16px;
`;

export const ProductSingleItemType = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: fit-content;
    max-height: 40px;
`;

export const ProductSingleItemInfo = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
`;

export const ProductSingleItemInfoName = styled.div`
    font-family: ${font.family.primary};
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    color: ${colors.darkGrey};
`;

export const ProductSingleItemDescription = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 16px;
`;

export const ProductSingleItemText = styled.span`
    font-family: ${font.family.primary};
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: ${colors.textSecondary};
`;

export const ProductSingleItemControl = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 100%;
    max-height: 40px;
`;

export const IconContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 100%;
`;

export const ProductSingleItemQuantity = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: fit-content;
    height: fit-content;
    padding: 6px 12px;
    background-color: #f2f2ff;
    border-radius: 6px;
`;

export const Wrapper = styled.div`
    margin-top: 3px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;

    font-family: ${font.family.primary};
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    color: ${colors.brandPrimary};
`;
